import React from 'react';

export const DownloadIcon: React.FC = () => (
    <svg
        width='16'
        height='16'
        viewBox='112.5 361 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M126.5 371V373.667C126.5 374.02 126.36 374.359 126.109 374.609C125.859 374.86 125.52 375 125.167 375H115.833C115.48 375 115.141 374.86 114.891 374.609C114.64 374.359 114.5 374.02 114.5 373.667V371'
            stroke='currentColor'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M117.167 367.667L120.5 371L123.833 367.667'
            stroke='currentColor'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M120.5 371V363'
            stroke='currentColor'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
